import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Phone, Mic, CheckSquare, Database, Calendar, ArrowRightLeft } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: Dedicated AI Phone Line — Your Business Always Answering | MindStream.ing
  Meta Desc: A dedicated phone number for every client relationship. MISTR handles every call — intake, follow-up, escalation — automatically. 24/7. Never misses.
  Primary KW: AI business phone line
*/
export function DedicatedLine() {
  return <FeaturePageLayout seoTitle="Dedicated Client Lines — 24/7 Support | MindStream.ing" seoDesc="A dedicated phone number for every client relationship. MISTR handles every call — intake, follow-up, escalation — automatically. 24/7. Never misses." heroEyebrow="DEDICATED LINE" heroTitle={<>
          A Direct Line to <span className="text-gradient" data-id="element-1522" data-mp="3ozj02n0llhmk">Action.</span>
        </>} heroDesc="A dedicated phone number for every client relationship. MR handles every call — intake, follow-up, escalation — automatically." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Client Calls',
      desc: 'Client calls their dedicated number anytime, 24/7.'
    }, {
      title: 'MR Answers',
      desc: 'MR answers, transcribes the call, and creates actionable tasks.'
    }, {
      title: 'Auto-Action',
      desc: 'CRM is updated and follow-ups are scheduled automatically.'
    }]
  }} features={{
    cards: [{
      icon: <Phone size={24} data-id="element-1523" data-mp="6ld4p7yze71b" />,
      title: 'Twilio-Powered Numbers',
      desc: 'Reliable, dedicated local or toll-free numbers for your business.'
    }, {
      icon: <Mic size={24} data-id="element-1524" data-mp="1w2h0kqrxvk24" />,
      title: 'Call Transcription',
      desc: 'Every conversation is perfectly transcribed and searchable in your ThinkTank.'
    }, {
      icon: <CheckSquare size={24} data-id="element-1525" data-mp="1mcp2hmkms8sw" />,
      title: 'Auto Task Creation',
      desc: 'Action items are extracted from the call and assigned to the right person.'
    }, {
      icon: <Database size={24} data-id="element-1526" data-mp="1cergl5q8uo3g" />,
      title: 'CRM Auto-Update',
      desc: 'Notes and deal stages are updated in your CRM immediately after hanging up.'
    }, {
      icon: <ArrowRightLeft size={24} data-id="element-1527" data-mp="13e3106l7cfog" />,
      title: 'Escalation Routing',
      desc: 'Smart routing transfers urgent or high-value calls directly to your cell.'
    }]
  }} demoTitle="Listen to a Call" demoDesc="Hear how natural it sounds when a client calls their dedicated line." demoCallout="Included in MR Pro" data-id="element-1521" data-mp="367qg1i3ib6qz" />;
}